import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  employeeReferralList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  employeeReferralDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
  careersJobPostList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  careersJobPostDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
  referralRelations: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
}

export const employeeReferralSlice = createSlice({
  name: 'employeeReferral',
  initialState,
  reducers: {
    getEmployeeReferralList: (state, action) => {
      state.employeeReferralList.requesting = true
      state.employeeReferralList.error = null
      state.employeeReferralList.items = []
      state.employeeReferralList.success = false
      state.employeeReferralList.filters = action.payload
    },
    getEmployeeReferralListSuccess: (state, action) => {
        const {data, current_page, per_page, total} = action.payload;
        state.employeeReferralList.requesting = false;
        state.employeeReferralList.items = data ?? [];
        
        state.employeeReferralList.pagination.current_page = current_page;
        state.employeeReferralList.pagination.per_page = per_page;
        state.employeeReferralList.pagination.total = total;
        state.employeeReferralList.success = true;
    },
    getEmployeeReferralListFail: (state, action) => {
      state.employeeReferralList.requesting = false
      state.employeeReferralList.error = action.payload
    },
    getEmployeeReferralDetails: (state) => {
      state.employeeReferralDetails.requesting = true
      state.employeeReferralDetails.error = null
      state.employeeReferralDetails.data = null
      state.employeeReferralDetails.success = false
    },
    getEmployeeReferralDetailsSuccess: (state, action) => {
      state.employeeReferralDetails.requesting = false
      state.employeeReferralDetails.data = action.payload
      state.employeeReferralDetails.success = true
    },
    getEmployeeReferralDetailsFail: (state, action) => {
      state.employeeReferralDetails.requesting = false
      state.employeeReferralDetails.error = action.payload
    },
    doEmployeeReferralCreate: (state) => {
      state.employeeReferralDetails.requesting = true
      state.employeeReferralDetails.error = null
      state.employeeReferralDetails.data = null
      state.employeeReferralDetails.success = false
    },
    doEmployeeReferralCreateSuccess: (state, action) => {
      state.employeeReferralDetails.requesting = false;
      state.employeeReferralDetails.data = action.payload;
      state.employeeReferralDetails.success = true;
    },
    doEmployeeReferralCreateFail: (state, action) => {
      state.employeeReferralDetails.requesting = false;
      state.employeeReferralDetails.error = action.payload;
      state.employeeReferralDetails.success = false;
    },
    doEmployeeReferralUpdate: (state) => {
      state.employeeReferralDetails.requesting = true
      state.employeeReferralDetails.error = null
      state.employeeReferralDetails.data = null
      state.employeeReferralDetails.success = false
    },
     doEmployeeReferralUpdateSuccess: (state, action) => {
      state.employeeReferralDetails.requesting = false;
      state.employeeReferralDetails.data = action.payload;
      state.employeeReferralDetails.success = true;
    },
    doEmployeeReferralUpdateFail: (state, action) => {
      state.employeeReferralDetails.requesting = false;
      state.employeeReferralDetails.error = action.payload;
      state.employeeReferralDetails.success = false;
    },
    doEmployeeReferralDelete: (state) => {
      state.employeeReferralDetails.requesting = true
      state.employeeReferralDetails.error = null
      state.employeeReferralDetails.data = null
      state.employeeReferralDetails.success = false
    },
    getCareersJobPostList: (state, action) => {
      state.careersJobPostList.requesting = true
      state.careersJobPostList.error = null
      state.careersJobPostList.items = []
      state.careersJobPostList.success = false
      state.careersJobPostList.filters = action.payload
    },
    getCareersJobPostListSuccess: (state, action) => {
      const {data, current_page, per_page, total} = action.payload;
      console.log(action.payload);
      state.careersJobPostList.requesting = false;
      state.careersJobPostList.items = data ?? [];
      
      state.careersJobPostList.pagination.current_page = current_page;
      state.careersJobPostList.pagination.per_page = per_page;
      state.careersJobPostList.pagination.total = total;
      state.careersJobPostList.success = true;
    },
    getCareersJobPostListFail: (state, action) => {
      state.careersJobPostList.requesting = false
      state.careersJobPostList.error = action.payload
    },

    getReferralRelationList: (state, action) => {
      state.referralRelations.requesting = true
      state.referralRelations.error = null
      state.referralRelations.items = []
      state.referralRelations.success = false
      state.referralRelations.filters = action.payload
    },
    getReferralRelationListSuccess: (state, action) => {
      state.referralRelations.requesting = false;
      state.referralRelations.items = action.payload;
      state.referralRelations.success = true;
    },
    getReferralRelationListFail: (state, action) => {
      state.referralRelations.requesting = false
      state.referralRelations.error = action.payload
    },

  },
})

export const {
  getEmployeeReferralList,
  getEmployeeReferralListSuccess, doEmployeeReferralCreateSuccess,
  getEmployeeReferralListFail, doEmployeeReferralCreateFail,
  getEmployeeReferralDetails, getEmployeeReferralDetailsSuccess,
  getEmployeeReferralDetailsFail, doEmployeeReferralCreate,
  doEmployeeReferralUpdateSuccess, doEmployeeReferralUpdateFail,
  doEmployeeReferralUpdate, doEmployeeReferralDelete,
  getCareersJobPostList, getCareersJobPostListSuccess, getCareersJobPostListFail,
  getReferralRelationList, getReferralRelationListSuccess, getReferralRelationListFail,
} = employeeReferralSlice.actions

export default employeeReferralSlice.reducer
